/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreGroupsUpdateInput } from '../../models/store-groups-update-input';
import { StoreGroupsUpdateOutput } from '../../models/store-groups-update-output';

export interface UpdateStoreGroup$Params {
  'Active-Tenant-Identifier': string;
  storeGroupId: string;
      body: StoreGroupsUpdateInput
}

export function updateStoreGroup(http: HttpClient, rootUrl: string, params: UpdateStoreGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreGroupsUpdateOutput>> {
  const rb = new RequestBuilder(rootUrl, updateStoreGroup.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeGroupId', params.storeGroupId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreGroupsUpdateOutput>;
    })
  );
}

updateStoreGroup.PATH = '/store-groups/{storeGroupId}';
